export default "__VITE_ASSET__CcZZO4Jf__"